export const RESTRICTED_USERS = [
    "zh.asil@janapost.kz",
    "a.zhamalova@janapost.kz",
    "a.kuandykova@janapost.kz",
    "b.naimanova@janapost.kz",
    "a.sovetov@janapost.kz",
    "z.turehanov@janapost.kz",
    "m.kungazy@janapost.kz",
    "n.abaidulla@janapost.kz",
    "a.doshybekov@janapost.kz",
    "r.ermekov@janapost.kz",
    // "a.kulsseitova@janapost.kz",
    "a.rakhymbayeva@janapost.kz",
    "s.sarsenkhanova@janapost.kz",
    "k.shymyrbai@janapost.kz",
    "a.abdugani@janapost.kz",
    "a.yesseyeva@janapost.kz",
    "z.tulegenova@janapost.kz",
    "a.babaeva@janapost.kz",
    "b.kaniyatova@janapost.kz",
    "t.shaken@janapost.kz",
    "u.elebukkyzy@janapost.kz",
    "madiyevaakbota947@gmail.com",
    "a.muratkazhy@janapost.kz",
    "y.madzhidova@janapost.kz",
    "n.tursynbek@janapost.kz",
    // "a.begimbetova@janapost.kz",
    "a.kebekbayeva@janapost.kz",
    "y.kadyrbekov@janapost.kz",
    "a.serikov@janapost.kz",
    "s.issatay@janapost.kz",
    // "t.aitova@janapost.kz",
    "d.alim@janapost.kz",
    "a.hismet@janapost.kz",
    "a.aitbayeva@janapost.kz",
    "g.alimkozha@janapost.kz",
]

export const RESTRICTED_USER_ALLOWED_ROUTES = ["PaymentOperations"]

export function isRestrictedUser(username) {
    if (!username) return false
    return RESTRICTED_USERS.includes(username.trim().toLowerCase())
}

export function hasRouteAccess(username, routeName) {
    if (isRestrictedUser(username)) {
        return RESTRICTED_USER_ALLOWED_ROUTES.includes(routeName)
    }
    return true
}
